import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, resolveDynamicComponent as _resolveDynamicComponent, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "absolute flex top-0 left-0 w-full h-full bg-brand-black/40 z-40 backdrop-blur"
}
const _hoisted_2 = { class: "flex px-10 m-auto text-white" }
const _hoisted_3 = { class: "rounded-3xl rounded-b-[44px] bg-brand-black/80 backdrop-blur flex p-5 shadow-2xl" }
const _hoisted_4 = { class: "flex flex-col items-center space-y-6" }
const _hoisted_5 = { class: "flex flex-col w-full items-center space-y-4 px-2" }
const _hoisted_6 = { class: "text-white text-lg font-medium text-center" }
const _hoisted_7 = { class: "text-2xl" }
const _hoisted_8 = { class: "flex justify-between shadow-2xl bg-brand-dark-gray text-white p-4 rounded-2xl w-full" }
const _hoisted_9 = { class: "flex flex-col" }
const _hoisted_10 = { class: "flex" }
const _hoisted_11 = { class: "text-lg font-medium" }
const _hoisted_12 = {
  key: 3,
  class: "flex w-full z-50",
  style: {"height":"calc(100% - 89px)"}
}
const _hoisted_13 = {
  key: 4,
  class: "flex h-full w-full"
}
const _hoisted_14 = {
  key: 5,
  class: "flex w-full",
  style: {"height":"calc(100% - 89px)"}
}
const _hoisted_15 = { class: "flex px-4 py-5 m-auto text-white" }
const _hoisted_16 = { class: "flex flex-col items-center space-y-6" }
const _hoisted_17 = { class: "flex flex-col w-full items-center space-y-0 px-2" }
const _hoisted_18 = { class: "text-brand-light-gray text-lg text-center" }
const _hoisted_19 = {
  key: 6,
  class: "flex flex-col w-full"
}
const _hoisted_20 = { class: "flex flex-col w-full" }
const _hoisted_21 = { class: "flex w-full py-4" }
const _hoisted_22 = ["onClick"]
const _hoisted_23 = { class: "flex w-full p-4 space-x-3" }
const _hoisted_24 = { class: "flex" }
const _hoisted_25 = { class: "flex flex-col w-full" }
const _hoisted_26 = { class: "flex space-x-2" }
const _hoisted_27 = { class: "text-white font-medium text-lg my-auto line-clamp-1" }
const _hoisted_28 = { class: "flex" }
const _hoisted_29 = { class: "flex text-brand-light-gray text-xs w-full justify-between space-x-2" }
const _hoisted_30 = { class: "flex line-clamp-1" }
const _hoisted_31 = { class: "flex min-w-max" }

import {computed, nextTick, onMounted, onUnmounted, onUpdated, PropType, ref, Ref, watch} from "vue";
import {UserInterface} from "@/interfaces/UserInterface";
import ApiService from "@/services/api/apiService";
import {UserBasicInformationInterface} from "@/interfaces/UserBasicInformationInterface";
import 'swiper/css';
import {debounce} from "lodash";
import {IonRefresher, IonRefresherContent, modalController, useIonRouter} from "@ionic/vue";
import {usePremium} from "@/composables/usePremium";
import UserAvatar from "@/components/UserAvatar.vue";
import UserVerificationCheck from "@/components/UserBadges.vue";
import {AccountType} from "@/definitions/AccountType";
import pluralize from "pluralize";
import MeetSheet from "@/views/common/MeetSheet.vue";
import NearbySheet from "@/views/common/NearbySheet.vue";
import {Observable, ObservableEvent} from "@/services/observable/Observable";
import InAppSubscription from "@/components/InAppSubscription.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'NearbyList',
  props: {
  accountType: {
    type: String as PropType<'individual' | 'couple' | 'club' | 'host' | undefined>,
    default: undefined
  },
  embedded: {
    type: Boolean,
    default: false,
  },
},
  setup(__props) {

/* eslint-disable no-undef */

const loading = ref(true)

const user: Ref<UserInterface | undefined> = ref()

const nearbyResults: Ref<UserBasicInformationInterface[]> = ref([])
const nearbyRadius = ref(60)

const meta: Ref<any> = ref()
const showInfiniteScroll = ref(true)

const busy = ref(false)

const props = __props

const getNearby = async (page = 1) => {
  if (busy.value) return
  try {
    busy.value = true
    const response: any = await ApiService.Feed().nearby(nearbyRadius.value, props.accountType, page)
    meta.value = response.meta

    if (page === 1) {
      nearbyResults.value = response.data
    } else {
      nearbyResults.value = [...nearbyResults.value, ...response.data]
    }
  } catch (e) {
    //
  } finally {
    loading.value = false
    busy.value = false
  }


}

const locationPermissions: Ref<any> = ref()

const observer = ref()

onMounted(async () => {
  user.value = await ApiService.User().authUser()
  if (user.value?.subscribed) nearbyRadius.value = 60
  if (user.value?.subscribed && props.accountType === AccountType.Club) nearbyRadius.value = 200
  await getNearby()

  loading.value = false

  setContainerHeight()
  addContainerEventListeners()


  observer.value = Observable.subscribe(async (response: any) => {
    if ([ObservableEvent.UserChanged].includes(response.event)) {
      user.value = await ApiService.User().get()
      await getNearby(1)
    }
  })

})

onUnmounted(() => {
  observer.value?.unsubscribe()
})

onUpdated(async () => {
  await nextTick()
})

const setContainerHeight = () => {
  if (!scrollContainer.value?.$el) return
  const scrollHost = scrollContainer.value.$el.closest('ion-content')
      ?? scrollContainer.value.$el.closest('.desktop-shell-main')
  const containerHeight = scrollHost?.clientHeight
  if (!containerHeight) return
  scrollContainer.value.$el.style.height = `${containerHeight - (props.embedded ? 0 : 92)}px`
}

const addContainerEventListeners = () => {
  if (!scrollContainer.value?.$el) return
  scrollContainer.value.$el.addEventListener("scroll", () => {
    handleScroll()
  });
}

watch(() => nearbyRadius.value, debounce(async () => {
  if (!loading.value) await getNearby(1)
}, 500))

const ionRouter = useIonRouter()

const viewUserProfile = async (userId: number) => {
  ionRouter.navigate({
    name: 'PineappleSearchUserProfile',
    params: {
      userId
    }
  }, 'forward', 'push')
}


const pullToRefresh = async (ev: any) => {
  await getNearby()
  ev.target.complete()
}

const handleScroll = async () => {
  if (!scrollContainer.value?.$el) return
  const threshold = 600; // Adjust this threshold as needed
  const scrollHost = scrollContainer.value.$el.closest('ion-content')
      ?? scrollContainer.value.$el.closest('.desktop-shell-main')
  const containerHeight = scrollHost?.clientHeight ?? scrollContainer.value.$el.offsetHeight
  const isScrolledToBottom = scrollContainer.value.$el.scrollTop >= scrollContainer.value.$el.offsetHeight - threshold;

  if (isScrolledToBottom) {
    let page = meta.value.current_page + 1
    if (page > meta.value.last_page) {
      return
    }
    await getNearby(page)
  }
}

const scrollContainer: Ref<any> = ref(null)

const setNearby = async () => {

  const sheet = await modalController.create({
    breakpoints: [0, 1],
    initialBreakpoint: 1,
    component: NearbySheet,
    mode: 'ios'
  })
  await sheet.present()

  const {data} = await sheet.onWillDismiss()
  if (data) {
    nearbyRadius.value = data
  }

}

const hasLocation = computed(() => {
  if (!user.value) return false
  return user.value?.location?.lat
})

const setLocation = async () => {
  await ionRouter.navigate({name: `ProfileSettingsLocation`}, 'forward', 'push')
}

const isSubscribed = computed(() => {
  return user.value?.subscribed
})



return (_ctx: any,_cache: any) => {
  const _component_DynamicScrollerItem = _resolveComponent("DynamicScrollerItem")!
  const _component_DynamicScroller = _resolveComponent("DynamicScroller")!

  return (_openBlock(), _createBlock(_resolveDynamicComponent(__props.embedded ? 'div' : 'ion-content'), {
    "force-overscroll": __props.embedded ? undefined : !!isSubscribed.value,
    class: _normalizeClass(__props.embedded ? 'nearby-list flex flex-col w-full min-h-full' : 'flex h-full')
  }, {
    default: _withCtx(() => [
      (!__props.embedded)
        ? (_openBlock(), _createBlock(_unref(IonRefresher), {
            key: 0,
            slot: "fixed",
            onIonRefresh: _cache[0] || (_cache[0] = ($event: any) => (pullToRefresh($event)))
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(IonRefresherContent), {
                "pulling-icon": "crescent",
                "refreshing-spinner": "crescent"
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (!isSubscribed.value && !loading.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("div", _hoisted_6, [
                      _createElementVNode("div", _hoisted_7, "Hey " + _toDisplayString(user.value.name) + "!", 1),
                      _cache[1] || (_cache[1] = _createTextVNode("This is a premium feature. ", -1))
                    ]),
                    _cache[2] || (_cache[2] = _createElementVNode("div", { class: "text-brand-light-gray text-lg text-center leading-tight" }, "Subscribe and get unrestricted access. ", -1))
                  ]),
                  _createVNode(InAppSubscription, {
                    class: "w-full",
                    label: "Get Pineapple Premium"
                  })
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (hasLocation.value)
        ? (_openBlock(), _createElementBlock("div", {
            key: 2,
            onClick: setNearby,
            class: "sticky top-0 flex w-full bg-brand-black p-4 z-50 space-x-3.5 border-b border-brand-dark-gray"
          }, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, "Within a " + _toDisplayString(nearbyRadius.value) + " " + _toDisplayString(_unref(pluralize)('mile', nearbyRadius.value)), 1)
                ])
              ]),
              _cache[3] || (_cache[3] = _createElementVNode("div", { class: "flex mr-2 my-auto" }, [
                _createElementVNode("svg", {
                  class: "w-5 fill-current text-white",
                  xmlns: "http://www.w3.org/2000/svg",
                  viewBox: "0 0 512 512"
                }, [
                  _createElementVNode("path", { d: "M239 401c9.4 9.4 24.6 9.4 33.9 0L465 209c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-175 175L81 175c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9L239 401z" })
                ])
              ], -1))
            ])
          ]))
        : _createCommentVNode("", true),
      (loading.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_12, [...(_cache[4] || (_cache[4] = [
            _createElementVNode("svg", {
              class: "animate-spin h-10 w-10 m-auto text-white",
              xmlns: "http://www.w3.org/2000/svg",
              fill: "none",
              viewBox: "0 0 24 24"
            }, [
              _createElementVNode("circle", {
                class: "opacity-25",
                cx: "12",
                cy: "12",
                r: "10",
                stroke: "currentColor",
                "stroke-width": "4"
              }),
              _createElementVNode("path", {
                class: "opacity-75",
                fill: "currentColor",
                d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
              })
            ], -1)
          ]))]))
        : _createCommentVNode("", true),
      (!loading.value && !hasLocation.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
            _createElementVNode("div", { class: "flex px-4 py-5 m-auto text-white" }, [
              _createElementVNode("div", { class: "flex flex-col items-center space-y-6" }, [
                _cache[5] || (_cache[5] = _createElementVNode("div", { class: "h-20 w-20 bg-brand-lime text-brand-black rounded-full flex" }, [
                  _createElementVNode("div", { class: "m-auto" }, [
                    _createElementVNode("svg", {
                      class: "w-6 fill-current",
                      xmlns: "http://www.w3.org/2000/svg",
                      viewBox: "0 0 384 512"
                    }, [
                      _createElementVNode("path", { d: "M215.7 499.2C267 435 384 279.4 384 192C384 86 298 0 192 0S0 86 0 192c0 87.4 117 243 168.3 307.2c12.3 15.3 35.1 15.3 47.4 0zM192 128a64 64 0 1 1 0 128 64 64 0 1 1 0-128z" })
                    ])
                  ])
                ], -1)),
                _cache[6] || (_cache[6] = _createElementVNode("div", { class: "flex flex-col w-full items-center space-y-0 px-2" }, [
                  _createElementVNode("div", { class: "flex text-white text-2xl font-medium text-center" }, "Profile Location Required"),
                  _createElementVNode("div", { class: "text-brand-light-gray text-lg text-center" }, " To use this feature you must have a location set and be sharing this on your profile. ")
                ], -1)),
                _createElementVNode("div", {
                  onClick: setLocation,
                  class: "bg-brand-dark-gray px-4 py-2.5 font-medium rounded-lg"
                }, "Set Location")
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (!loading.value && hasLocation.value && !nearbyResults.value.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("div", _hoisted_16, [
                _cache[8] || (_cache[8] = _createElementVNode("div", { class: "h-20 w-20 bg-brand-dark-gray text-brand-light-gray rounded-full flex" }, [
                  _createElementVNode("div", { class: "m-auto" }, [
                    _createElementVNode("svg", {
                      class: "w-6 fill-current",
                      xmlns: "http://www.w3.org/2000/svg",
                      viewBox: "0 0 384 512"
                    }, [
                      _createElementVNode("path", { d: "M215.7 499.2C267 435 384 279.4 384 192C384 86 298 0 192 0S0 86 0 192c0 87.4 117 243 168.3 307.2c12.3 15.3 35.1 15.3 47.4 0zM192 128a64 64 0 1 1 0 128 64 64 0 1 1 0-128z" })
                    ])
                  ])
                ], -1)),
                _createElementVNode("div", _hoisted_17, [
                  _cache[7] || (_cache[7] = _createElementVNode("div", { class: "flex text-white text-2xl font-medium text-center" }, "Is there anybody out there?", -1)),
                  _createElementVNode("div", _hoisted_18, " We couldn't find any profiles within " + _toDisplayString(nearbyRadius.value) + " " + _toDisplayString(_unref(pluralize)('mile', nearbyRadius.value)) + " of your location. Try searching a little further afield. ", 1)
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (!loading.value && hasLocation.value && nearbyResults.value.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
            _createElementVNode("div", _hoisted_20, [
              _createVNode(_component_DynamicScroller, {
                ref_key: "scrollContainer",
                ref: scrollContainer,
                "min-item-size": 76,
                items: nearbyResults.value,
                class: "scroller flex pb-4"
              }, {
                default: _withCtx(({ item, index, active }) => [
                  _createElementVNode("div", _hoisted_21, [
                    _createVNode(_component_DynamicScrollerItem, {
                      item: item,
                      active: active,
                      "data-index": index,
                      class: "w-full pb-4 px-4"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", {
                          onClick: ($event: any) => (viewUserProfile(item.id)),
                          class: "flex bg-brand-dark-gray rounded-2xl"
                        }, [
                          _createElementVNode("div", _hoisted_23, [
                            _createElementVNode("div", _hoisted_24, [
                              _createVNode(UserAvatar, { user: item }, null, 8, ["user"])
                            ]),
                            _createElementVNode("div", _hoisted_25, [
                              _createElementVNode("div", _hoisted_26, [
                                _createElementVNode("div", _hoisted_27, _toDisplayString(item.name), 1),
                                _createElementVNode("div", _hoisted_28, [
                                  _createVNode(UserVerificationCheck, {
                                    class: "h-4",
                                    user: item
                                  }, null, 8, ["user"])
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_29, [
                                _createElementVNode("div", _hoisted_30, _toDisplayString(item.location ? item.location.name : '--'), 1),
                                _createElementVNode("div", _hoisted_31, _toDisplayString(item.distance_label), 1)
                              ])
                            ])
                          ])
                        ], 8, _hoisted_22)
                      ]),
                      _: 2
                    }, 1032, ["item", "active", "data-index"])
                  ])
                ]),
                _: 1
              }, 8, ["items"])
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["force-overscroll", "class"]))
}
}

})